module.exports = __webpack_public_path__ + "static/media/pc2.35c5f11c.png";